<mat-card class="shadow-box">


  <mat-card-header style="display: block;padding: 0;">
    <h1 class="titulo-simpli">Ranking clientes con ventas</h1>
    <small class="subtitulo-simpli">{{ this.date_start}} / {{ this.date_end}}</small>
  </mat-card-header>

  <mat-card-content>

    @if (ELEMENT_DATA.length > 0 && loading == false) {
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 col-top">
          <mat-form-field>
            <mat-label>Filtrar</mat-label>
            <input matInput (keyup)="applyFilter($event.target.value)">
          </mat-form-field>
        </div>
      </div>
    }

    @if (ELEMENT_DATA.length > 0 && loading == false) {
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
          <div class="table-responsive-simpli">
            <table class="table" mat-table [dataSource]="dataSource">
              <ng-container matColumnDef="business_name">
                <th mat-header-cell *matHeaderCellDef> Cliente </th>
                <td mat-cell *matCellDef="let element" >
                  <input class="no-input" readonly matTooltip="{{element?.business_name}}" value="{{element.business_name}}">
                </td>
                <td mat-footer-cell *matFooterCellDef style="font-weight: bold;text-align: center;">{{anotherArray[0]?.business_name}}</td>
              </ng-container>
              <ng-container matColumnDef="conteo">
                <th mat-header-cell *matHeaderCellDef> Cantidad </th>
                <td mat-cell *matCellDef="let element"><input class="no-input" readonly value="{{element.conteo}}"></td>
                <td mat-footer-cell *matFooterCellDef style="font-weight: bold;text-align: center;">{{anotherArray[0]?.conteo}}</td>
              </ng-container>
              <ng-container matColumnDef="monto">
                <th mat-header-cell *matHeaderCellDef> Monto </th>
                <td mat-cell *matCellDef="let element"><input class="no-input" readonly value="${{formatMoney(element.monto)}}"></td>
                <td mat-footer-cell *matFooterCellDef style="font-weight: bold;text-align: center;">${{formatMoney(anotherArray[0]?.monto)}}</td>
              </ng-container>
              <ng-container matColumnDef="porcentaje">
                <th mat-header-cell *matHeaderCellDef> Porcentaje </th>
                <td mat-cell *matCellDef="let element"><input class="no-input" readonly value="{{element.porcentaje}}%"></td>
                <td mat-footer-cell *matFooterCellDef style="font-weight: bold;text-align: center;">{{anotherArray[0]?.porcentaje}}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; let element; columns: displayedColumns;"></tr>
              <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
            </table>
            <mat-paginator  #paginator [length]="this.len_info" [pageSize]="5"></mat-paginator>
          </div>
        </div>
      </div>
    }


    @if (ELEMENT_DATA.length == 0 && loading == false) {
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
          <div class="empty-msg">
            <div style="padding-top: 50px;text-align: center;">
              <span class="material-symbols-outlined" style="font-size: 45px;color:var(--simpli-color6)">manage_search</span>
            </div>
            <div style="padding-top: 50px;text-align: center;">
              <mat-label class="label-bienvenida">
                <div class="label-empty">
                  ¡Ups! Al parecer no estas sincronizado.
                </div>
                <div class="label-empty" style="margin-top: 20px;">
                  Cargar tus credenciales y dale click al botón sincronizar información en la parte superior.
                </div>
              </mat-label>
            </div>
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="btn-simpli-container">
                  <button class="primary-button" (click)="open_credenciales()" mat-flat-button>Cargar credenciales</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    @if (ELEMENT_DATA.length == 0 && loading == true) {
      <div class="row animate__animated animate__fadeIn">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="sinRegistros" style="text-align: center;">
            <small class="small-sinregistros" style="font-size: 15px;margin-top: 20px;">
              <div style="text-align: center;">
                <span class="material-symbols-outlined mat-spin" style="font-size: 30px;color:gray;margin-bottom: 20px;">progress_activity</span>
              </div>
            </small>
          </div>
        </div>
      </div>
    }


  </mat-card-content>
</mat-card>
